/**
 * Mobile focus guard
 * On touch devices, a text field (newsletter, search, etc.) should only take
 * focus, and open the on-screen keyboard, when the visitor actually taps it,
 * taps its label, or uses a keyboard. Any other focus (a script, an app popup,
 * a lightbox restoring focus after it closes) is undone, so tapping images no
 * longer pops the keyboard open.
 * Add data-allow-programmatic-focus to a field to opt it out.
 */
(() => {
  if (!window.matchMedia || !window.matchMedia("(pointer: coarse)").matches) return;

  const TEXT_FIELDS = [
    "input:not([type])",
    'input[type="text"]',
    'input[type="email"]',
    'input[type="search"]',
    'input[type="tel"]',
    'input[type="url"]',
    'input[type="number"]',
    'input[type="password"]',
    "textarea",
    '[contenteditable=""]',
    '[contenteditable="true"]'
  ].join(",");

  // focus that the visitor asked for: search drawer input after tapping the search icon
  const ALLOWED = ".js-drawer-focus-element, [data-allow-programmatic-focus]";
  const WINDOW_MS = 1500;

  let lastTapTarget = null;
  let lastTapTime = 0;
  let lastKeyTime = 0;

  const rememberTap = event => {
    lastTapTarget = event.target;
    lastTapTime = Date.now();
  };

  document.addEventListener("pointerdown", rememberTap, true);
  document.addEventListener("touchstart", rememberTap, { capture: true, passive: true });
  document.addEventListener("keydown", () => { lastKeyTime = Date.now(); }, true);

  const tappedField = field => {
    if (!lastTapTarget || Date.now() - lastTapTime > WINDOW_MS) return false;
    if (field === lastTapTarget || field.contains(lastTapTarget)) return true;
    const label = lastTapTarget.closest && lastTapTarget.closest("label");
    return !!label && label.control === field;
  };

  document.addEventListener(
    "focusin",
    event => {
      const field = event.target;
      if (!(field instanceof Element) || !field.matches(TEXT_FIELDS)) return;
      if (field.matches(ALLOWED)) return;
      if (Date.now() - lastKeyTime < WINDOW_MS) return;
      if (tappedField(field)) return;
      field.blur();
    },
    true
  );
})();
